import { createInMemoryAtom } from '@exodus/atoms';
const createTxLogMonitorsTickAtom = () => createInMemoryAtom({
    defaultValue: true,
});
export const isTxLogMonitorsSingleTickAtom = {
    id: 'isTxLogMonitorsSingleTickAtom',
    type: 'atom',
    factory: createTxLogMonitorsTickAtom,
    public: true,
    override: true,
};
const createIsTxLogMonitorsSingleTickPlugin = ({ isTxLogMonitorsSingleTickAtom, }) => {
    return {
        onLoad: async () => {
            isTxLogMonitorsSingleTickAtom.set(false);
        },
    };
};
export const isTxLogMonitorsSingleTickPlugin = {
    id: 'isTxLogMonitorsSingleTickPlugin',
    type: 'plugin',
    factory: createIsTxLogMonitorsSingleTickPlugin,
    dependencies: ['isTxLogMonitorsSingleTickAtom'],
    public: true,
};
